var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./rtBreadcrumbItem.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6fa42a26\"}!../../../../vue-loader/lib/selector?type=template&index=0!./rtBreadcrumbItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/breadcrumb/rtBreadcrumbItem.vue
// module id = 1910
// module chunks = 137